import {
    Grid,
    SelectChangeEvent,
    Theme,
    Typography
} from "@mui/material";
import { MFTextField } from "../../../../lib/formik";
import { TextDatePicker } from "../../../onboarding/DatePickerWithTextFeild";
import MFSelectField from "../../../../lib/formik/SelectField";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../../redux-store/reducers";
import {
    FormikContextType,
    useFormikContext
} from '../../../../lib/formik/Formik';
import { allowDecimalNumbers } from "../../../../utils/utilityFunctions";
import dayjs from "../../../../utils/dayjs";
import { CurrencyConversionToWords } from "../commonComponents";

export default function CorpusInOutForm({
    isLoading
}: {
    isLoading: boolean;
}): JSX.Element {
    const { currencySymbol } = useSelector((store: RootStateType) => store.currencyInfo);
    const { businessDate = "" } = useSelector((store: RootStateType) => store.navbarInfo);

    const {
        values,
        setFieldValue,
        resetForm
    }: FormikContextType<Record<string, any>> = useFormikContext();

    const handleOrderDateChange = (selectedDate: any) => {
        setFieldValue('orderDate', selectedDate?.isValid() ? selectedDate : "", true)
    }

    const handleAmountPaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
        event.preventDefault()
        const clipboardData = event.clipboardData.getData("text")

        const modifiedText = `${clipboardData ?? ""}`?.replaceAll(",", "")

        setFieldValue("amount", modifiedText);
    }

    const handleTransactionTypeChange = async (event: SelectChangeEvent<unknown>) => {
        resetForm({
            values: {
                ...values,
                transactionType: event.target.value,
                settlementMethod: ""
            }
        })
    }

    const refactoredAmount = `${values?.amount ?? ""}`?.replaceAll(',', '')

    return (
        <Grid
            container
            columnSpacing={3}
        >
            {/* <Grid item xs={12} lg={4}>
                <MFTextField
                    name="orderNumber"
                    label="Order Number"
                    placeholder=""
                />
            </Grid> */}
            <Grid item xs={12} lg={4}>
                <TextDatePicker
                    name="orderDate"
                    label="Order Date *"
                    placeholder=""
                    maxDate={
                        businessDate ?
                            dayjs(businessDate, "DD/MM/YYYY").toDate() :
                            new Date()
                    }
                    customHandleChange={handleOrderDateChange}
                    disabled
                />
            </Grid>
            <Grid item xs={12} lg={4}>
                <MFSelectField
                    name="transactionType"
                    label="Transaction Type *"
                    items={[
                        { name: "Corpus In" },
                        { name: "Corpus Out" },
                    ].map((obj) => ({
                        key: obj.name,
                        value: obj.name,
                    }))}
                    onChange={handleTransactionTypeChange}
                    disabled={isLoading}
                />
            </Grid>
            <Grid item xs={12} lg={4}>
                <MFTextField
                    name="amount"
                    label="Amount *"
                    placeholder=""
                    startAdornment={values?.amount ? (
                        <Typography
                            variant='body_500'
                            sx={(theme: Theme) => ({
                                color: isLoading ? theme.palette.text.secondary : theme.palette.text.primary
                            })}
                        >
                            {String.fromCharCode(parseInt(currencySymbol, 16))}
                        </Typography>
                    ) : undefined}
                    sx={{
                        '&.MuiOutlinedInput-root': {
                            "& fieldset>legend": {
                                fontSize: "0.78em",
                            }
                        }
                    }}
                    onKeyDown={allowDecimalNumbers}
                    formatCurrency
                    onPaste={handleAmountPaste}
                    value={values?.amount ?? ""}
                    disabled={isLoading}
                />
                <CurrencyConversionToWords value={refactoredAmount} />
            </Grid>
            <Grid item xs={12}>
                <MFTextField
                    name="remarks"
                    label="Remarks *"
                    placeholder=""
                    multiline
                    inputProps={{ maxLength: 200 }}
                    value={values?.remarks ?? ""}
                    disabled={isLoading}
                />
                <Typography
                    variant="overline_400"
                    sx={(theme: Theme) => ({
                        textAlign: "end",
                        color: theme.palette.text.secondary,
                        marginTop: "-10px"
                    })}
                >
                    Max 200 characters
                </Typography>
            </Grid>
        </Grid>
    )
}